module.exports = __webpack_public_path__ + "img/logo-um-fnm-ang.a0997429.png";